import { useCallback, useState } from 'react'

import { api } from 'app/api'
import {
  RESTORE_SURVEY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/id/restore'
import type { Survey } from 'app/common/types/surveys'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

type Options = {
  surveyId: Survey['id']
  onSuccess?: () => void
}

export const useRestoreSurvey = ({ surveyId, onSuccess }: Options) => {
  const [pending, setPending] = useState(false)
  const onSuccessRef = useCallbackRef(onSuccess)

  const submit = useCallback(async () => {
    setPending(true)
    try {
      const result = await api.request(RESTORE_SURVEY, {
        params: { surveyId },
        convertions: { convertParams, convertResult },
        error: (error: Error & { response?: { data?: { message?: string } } }) =>
          error.response?.data?.message || 'Не удалось восстановить опрос',
      })
      if (result) onSuccessRef.current?.()
      return result
    } finally {
      setPending(false)
    }
  }, [surveyId, onSuccessRef])

  return { pending, submit }
}
